export const NOTEBOOK_REGISTRATION = '/notebook-registration'
export const NOTEBOOK_REGISTRATION_STUDENT = '/notebook-registration-student'
